import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="rs-grid-bg rs-scanlines min-h-screen text-white flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-[#0F1219] border border-slate-700 p-10 text-center relative z-[2] rs-fade-up">
        <XCircle className="w-14 h-14 mx-auto text-slate-500 mb-6" />
        <h1 className="font-mono-rs text-xl uppercase tracking-wide mb-2">Donation cancelled</h1>
        <p className="text-sm text-slate-400 mb-8">No worries — you weren't charged. You can donate any time.</p>
        <div className="flex gap-3">
          <button data-testid="cancel-retry" onClick={() => navigate("/donate")}
            className="flex-1 py-3 bg-[#D902EE]/20 border border-[#D902EE] font-mono-rs uppercase text-xs tracking-[0.15em] hover:bg-[#D902EE]/30 transition-all">
            Donate
          </button>
          <button data-testid="cancel-home" onClick={() => navigate("/")}
            className="flex-1 py-3 border border-slate-600 font-mono-rs uppercase text-xs tracking-[0.15em] hover:border-white transition-all">
            Back to app
          </button>
        </div>
      </div>
    </div>
  );
}
